<script>
export default {
  name: 'BookmakerOddsButton',
  props: {
    bookmakerId: {
      type: String,
      default: () => '',
    },
    bookmakerLink: {
      type: String,
      default: () => '/',
    },
    value: {
      type: [String, Number],
      default: () => '',
    },
  },
};
</script>

<template>
  <div class="bookie-odds-button__container">
    <a
      :href="bookmakerLink"
      :class="`bookie-odds-button__btn bookmaker-odds-${bookmakerId}`"
      target="_blank"
    >
      <div class="bookie-odds-button__image"></div>
      <div class="bookie-odds-button__btn-txt">
        <div class="bookie-odds-button__text">Bet Now</div>
        <div class="bookie-odds-button__value">
          <span v-if="value">${{ value | twoDecimalPlaces }}</span>
          <span v-else style="font-size: 9px;">Loading...</span>
        </div>
      </div>
    </a>
  </div>
</template>
